const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Admin Dashboard</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <a
            href="/admin/hosts"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Host Approvals</h2>
            <p className="text-gray-600">Review and approve host applications</p>
          </a>
          <a
            href="/admin/trips"
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Trip Approvals</h2>
            <p className="text-gray-600">Review and publish trips</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

